import service from '@/store/services/if-release-service';

const state = {
  years: null,
  releaseId: null,
  addQ2: false,
  loaded: false,
};

const mutations = {
  SET_IF_RELEASE_YEARS: (state, payload) => {
    state.years = payload.years;
    state.releaseId = payload.release_id;
    state.addQ2 = payload.add_q2;
    state.loaded = true;
  },
};

const actions = {
  fetchIfReleaseYears({ commit }, params = {}) {
    return service
      .get(params)
      .then((res) => {
        if (res.hasOwnProperty('data') && res.data.error) {
          commit('SET_ERROR_BIT', true, { root: true });
          commit(
            'SET_ERROR_INFO',
            '<br>' +
              'Server responded with error = True <br> errorCode: ' +
              res.data.errorCode,
            { root: true }
          );
          return res.data;
        }
        commit('SET_IF_RELEASE_YEARS', res.data);
        return res.data;
      })
      .catch((err) => {
        commit('SET_ERROR_BIT', true, { root: true });
        commit('SET_ERROR_INFO', err.stack, { root: true });
      });
  },
};

const getters = {
  years: (state) => state.years,
  yearAt: (state) => (index) => (state.years ? state.years[index] : undefined),
  addQ2: (state) => state.addQ2,
  releaseId: (state) => state.releaseId,
  loaded: (state) => state.loaded,
};

const ifRelease = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default ifRelease;
